var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFinishTurn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17273_2431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.666992C14.8421 0.666992 17.5192 1.70171 19.6064 3.59473L20.0156 3.98438C22.1558 6.1243 23.333 8.96855 23.333 12C23.333 18.2487 18.2483 23.333 12 23.333C9.15789 23.333 6.48042 22.2982 4.39355 20.4053L3.98438 20.0156C1.84422 17.8757 0.666992 15.0315 0.666992 12C0.666992 5.75125 5.75125 0.666992 12 0.666992ZM4.67676 19.7939L5.24609 20.2607C7.14674 21.8193 9.50952 22.667 12 22.667C17.8821 22.667 22.667 17.8821 22.667 12C22.667 9.50952 21.8193 7.14674 20.2607 5.24609L19.7939 4.67676L4.67676 19.7939ZM12 1.33301C6.11789 1.33301 1.33301 6.11789 1.33301 12C1.33301 14.4905 2.1807 16.8533 3.73926 18.7539L4.20605 19.3232L4.72656 18.8027L18.8018 4.72656L19.3223 4.20605L18.7529 3.73926C16.8528 2.1808 14.4898 1.33301 12 1.33301Z",
    fill: "#2D6772",
    stroke: "#2D6772",
    strokeWidth: 1.33333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17273_2431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFinishTurn);
export default __webpack_public_path__ + "static/media/ic_finish_turn.be9079d7271c62616a5c8dda2aba7b7e.svg";
export { ForwardRef as ReactComponent };